export const ChainTypes = {
  SINGLE_OWNER: 'SINGLE_OWNER',
  FRANCHISEE: 'FRANCHISEE',
  NO_RELATIONS: 'NO_RELATIONS',
}
